import { render, staticRenderFns } from "./LoginAs.vue?vue&type=template&id=66f1afaa"
import script from "./LoginAs.vue?vue&type=script&lang=js"
export * from "./LoginAs.vue?vue&type=script&lang=js"
import style0 from "./LoginAs.vue?vue&type=style&index=0&id=66f1afaa&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports